module.exports = __webpack_public_path__ + "res/glyphicons-halflings-regular.woff?fa2772327f55d8198301fdb8bcfc8158";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.woff
// module id = 7
// module chunks = 0